module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@2x-58c35ab293420686e698092c46da29da.png";